import { convertDateToUTC, convertDateToUTCEpoch } from '../../Helper/date'

const getPaginationRange = (totalPages, currentPage, siblingCount = 2) => {
    const totalPageNumbers = siblingCount * 2 + 5;

    if (totalPages <= totalPageNumbers) {
        return Array.from({ length: totalPages }, (_, idx) => idx + 1);
    }

    const leftSibling = Math.max(currentPage - siblingCount, 2);
    const rightSibling = Math.min(currentPage + siblingCount, totalPages - 1);

    const showLeftDots = leftSibling > 2;
    const showRightDots = rightSibling < totalPages - 1;

    const range = [];

    range.push(1);

    if (showLeftDots) range.push('...');
    for (let i = leftSibling; i <= rightSibling; i++) {
        range.push(i);
    }
    if (showRightDots) range.push('...');

    range.push(totalPages);

    return range;
};


const inventoryColumns = [
    {
        id: 'shed',
        header: 'SHED',
        filterBody: 'input'
    },
    {
        id: 'aor',
        header: 'AOR',
        filterBody: 'input'
    },
    {
        id: 'mawb',
        header: 'MAWB',
        filterBody: 'input'
    },
    {
        id: 'hawb',
        header: 'HAWB',
        filterBody: 'input'
    },
    {
        id: 'srf',
        header: 'SRF',
        filterBody: 'input'
    },
    {
        id: 'status1',
        header: 'STATUS 1',
        filterBody: 'input'
    },
    {
        id: 'npx',
        header: 'NPX',
        filterBody: 'input'
    },
    {
        id: 'npr',
        header: 'NPR',
        filterBody: 'input'
    },
    {
        id: 'gwt',
        header: 'GWT',
        filterBody: 'input'
    },
    {
        id: 'goodsDescription',
        header: 'GOODS DESCRIPTION',
        filterBody: 'input'
    },
    {
        id: 'aoo',
        header: 'AOO',
        filterBody: 'input'
    },
    {
        id: 'aod',
        header: 'AOD',
        filterBody: 'input'
    },
    {
        id: 'sdc',
        header: 'SDC',
        filterBody: 'input'
    },
    {
        id: 'flight',
        header: 'FLIGHT',
        filterBody: 'input'
    },
    {
        id: 'agent',
        header: 'AGENT',
        filterBody: 'input'
    },
    {
        id: 'customsStatus',
        header: 'CUSTOMS STATUS',
        filterBody: 'input'
    },
    {
        id: 'status2Ind',
        header: 'STATUS 2 IND',
        filterBody: 'input'
    },
    {
        id: 'createdDate',
        header: 'CREATED DATE',
        filterBody: 'date',
        body: 'date'
    }
]

const transformFilters = (filters) => {
    if (!filters) return undefined;
    return Object.entries(filters).reduce((prev, [key, value]) => {
        if (value.value) {
            return {
                ...prev,
                [key]:
                    typeof value.value === 'string'
                        ? value.value?.trim()?.toLowerCase()
                        : value.value,
            };
        }
        return prev;
    }, {});
};

const convertEpochToUTC = (value) => {
    if (!value) return -999;
    const date = new Date(Number(value));
    const months = [
        'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
        'JUL', 'AUG', 'SEPT', 'OCT', 'NOV', 'DEC'
    ];
    return `${date.getUTCDate()}-${months[date.getUTCMonth()]}- ${date.getUTCFullYear()}`;
};

const convertDateToUTCInSec = (value) => {
    return convertDateToUTC(Number(value) * 1000)
}
const convertDateToUTCEpochInSec = (value) => {
    return convertDateToUTCEpoch(value) / 1000
}

export {
    getPaginationRange,
    transformFilters,
    inventoryColumns,
    convertEpochToUTC,
    convertDateToUTCInSec,
    convertDateToUTCEpochInSec
}
